(function(){
'use strict';

onIOSBlur.$inject = ["$window"];
function onIOSBlur($window) {
  var iOS = $window.navigator.userAgent.match(/(iPad|iPhone|iPod)/g) && !$window.MSStream;

  return function (element, cb) {
    if (!iOS) return _.noop;

    function handler() {
      /**
       * Fix for a bug where tapping First/Last Name, Email, etc input field on Chrome
       * for iOS (iPhone 13, SE 2nd Gen, iOS 15-16) fails to open the keyboard.
       * Originally, onIOSBlur triggered handleBlur for any touchstart/focusin outside
       * cpTokenizerControl (Credit Card field), disturbing focus.
       * The fix  - trigger cb (handleBlur) only if the Credit Card field is focused,
       * triggering blur and validation. Prevents unnecessary handleBlur calls when
       * tapping First Name First/Last Name, Email, other input fields, without Credit Card interaction.
       */
      if (document.activeElement === element[0]) {
        cb();
      }
    }

    angular.element($window).on('touchstart focusin', handler);

    return function () {
      return angular.element($window).off('touchstart focusin', handler);
    };
  };
}

angular.module('classy').factory('onIOSBlur', onIOSBlur);
})();